// extracted by mini-css-extract-plugin
export default {"item":"item_item","link":"item_link"};